export default __webpack_public_path__ + "static/media/Jenna-Avatar.719298f5.png";